var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({staticClass:"pro-switch",class:{ 'pro-switch--large': _vm.large },attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }